// ThyroidCard.jsx

import React from "react";
import BasePackageCard from "./BasePackageCard";
import { THYROID } from "../../../../constants";
import { useTranslation } from "../../../../language";

export default function ThyroidCard() {
  const { t } = useTranslation();

  const panel = {
    id: "thyroid",
    title: t("card_thyroid_title"),
    subtitle: t("card_thyroid_desc"),
    biomarkers: t("card_thyroid_markers"),
    price: "€ 79",
    image: THYROID,
  };

  return <BasePackageCard panel={panel} />;
}